module.exports = __webpack_public_path__ + "img/015-quality.ea07e7b6.svg";